import React from 'react';
import '../Colors.css';

const Info = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslHighlightYellow' d="M1024.007 512.853c0 282.375-229.64 510.306-512.007 510.306-282.371 0-512.011-227.934-512.011-510.306 0.004-284.073 229.64-512.011 512.011-512.011s512.007 227.938 512.007 512.011zM608.956 506.047c0-54.437-35.72-96.96-90.154-96.96h-93.557c-45.929 0-73.142 30.623-73.142 69.743 0 34.023 22.116 69.743 93.557 69.743v234.74c0 54.43 28.918 96.956 81.65 96.956 54.433 0 81.65-42.526 81.65-96.956v-277.267zM622.568 228.78c0-57.836-47.627-95.254-110.564-95.254s-110.571 37.418-110.571 95.254v8.504c0 57.836 47.631 96.96 110.568 96.96s110.564-39.127 110.564-96.96v-8.504z"/>
    </svg>
  );
};

export default Info;